import React from 'react'
import './lookingfor.css'
import { PiBuildingApartment } from "react-icons/pi";
import { FaHouseChimney } from "react-icons/fa6";
import { RiHomeOfficeLine } from "react-icons/ri";
const LookingFor = () => {
  return (
    <section className='lookingfor-overlay'>
          <div className='lookingforcontainer'>
        <h3 className='text-center p1 textwhite'>We're Here To Help You</h3>
        <h1 className='text-center p1 textwhite'>What Are You Looking For?</h1>
        <div className="container innerfinds p2">
            <article className='finds'>
                <div className='icon-cont'><PiBuildingApartment className='textwhite text-center iconss'/></div>
                <h3 className='textwhite text-center'>APARTMENTS</h3>
                <p className='textwhite text-justify'>Want a stylish, low-maintenance home? We have apartments that fit your lifestyle whether you need a studio for one or a spacious unit for your family. Think modern designs, great locations, and amenities that make life easier. Tell us what you need, and we’ll find it for you.</p>
                <div className='auto'>
                    <button className='btn'><a className='propbtn' href="https://wa.me/2348085312366?text=Hello%20there!%20I%20am%20looking%20for%20an%20apartment.">Find Apartments</a></button>
                </div>
            </article>
            <article className='finds'>
                <div className='icon-cont'><FaHouseChimney className='textwhite text-center iconss'/></div>
                <h3 className='textwhite text-center'>HOUSES</h3>
                <p className='textwhite text-justify'>Dreaming of a place to call your own? We offer houses in great neighborhoods—perfect for families, couples, or anyone who wants more space. From charming starter homes to luxury estates, we’ll help you find the right fit. Just tell us your wishlist!</p>
                <div className='auto'>
                    <button className='btn'><a className='propbtn' href="https://wa.me/2348085312366?text=Hello%20there!%20I%20am%20looking%20for%20a%20House.">Find Apartments</a></button>
                </div>
            </article>
            <article className='finds'>
                <div className='icon-cont'><RiHomeOfficeLine className='textwhite text-center iconss'/></div>
                <h3 className='textwhite text-center'>OFFICES</h3>
                <p className='textwhite text-justify'>Need a professional space for your business? We source offices that boost productivity—whether you’re a startup needing a small suite or a growing company looking for a full floor. Prime locations, flexible leases, and move-in-ready spaces. We’ll handle the search—you focus on success.</p>
                <div className='auto'>
                    <button className='btn'><a className='propbtn' href="https://wa.me/2348085312366?text=Hello%20there!%20I%20am%20looking%20for%20an%20Office.">Find Apartments</a></button>
                </div>
            </article>
        </div>
    </div>
    </section>
  
  )
}

export default LookingFor